export default '/build/ddf4ef5b.png'